import type { RouteObject } from "react-router-dom";

import { ReportBuilderPage } from "./pages/ReportBuilderPage";
import { ReportDefinitionListPage } from "./pages/ReportDefinitionListPage";
import { ReportResultPage } from "./pages/ReportResultPage";
import ReportDefinitionListHelp from "./help/report-definition-list.mdx";
import ReportBuilderHelp from "./help/report-builder.mdx";
import ReportResultHelp from "./help/build-report-export-url.mdx";

// ADR-096 Rule RPT-08. permission_domain مورد نیاز هر مسیر (برای gate
// سطح route که قبلاً در پروژه استفاده می‌شود — reporting.view /
// reporting.manage) باید طبق همان الگویی که سایر featureها (forms,
// quality, ...) برای route guarding دارند اعمال شود.
export const reportingRoutes: RouteObject[] = [
  { path: "help/reporting/definitions", element: <ReportDefinitionListHelp /> },
  { path: "help/reporting/builder", element: <ReportBuilderHelp /> },
  { path: "help/reporting/results", element: <ReportResultHelp /> },
  { path: "/reporting", element: <ReportDefinitionListPage /> },
  { path: "/reporting/new", element: <ReportBuilderPage /> },
  { path: "/reporting/:id/edit", element: <ReportBuilderPage /> },
  { path: "/reporting/:id/run", element: <ReportResultPage /> },
];
